import { apiFetch } from '@m/utils/http';

import { HospitalityStayStatus, HospitalityStayType, StaySiteType } from '../types';

export type HospitalityStayForm = {
  active: boolean;
  checkInDate?: number;
  checkOutDate?: number;
  driverFirstName: string;
  driverLastName: string;
  guestFirstName?: string;
  guestLastName?: string;
  hotelName: string;
  hotelTicketNumber: string;
  intakePartnerId: number;
  isOversizedVehicle?: boolean;
  roomNumber?: string;
  siteId: number;
  siteType: StaySiteType;
  status: HospitalityStayStatus;
  stayType: HospitalityStayType;
  visitEnd?: number;
  visitStart: number;
};

export type HospitalityEditForm = {
  checkInDate?: number;
  checkOutDate?: number;
  guestFirstName?: string;
  guestLastName?: string;
  hotelName?: string;
  hotelTicketNumber?: string;
  roomNumber?: string;
};

const INTAKE_BASE_PATH = '/v2/intake';

export const HospitalityService = {
  getIntakePartnerDetails: (userId: number) =>
    apiFetch(`${INTAKE_BASE_PATH}/intake-partners/${userId}`),

  getOpenHospitalityStays: (IntakePartnerId: number) =>
    apiFetch(`${INTAKE_BASE_PATH}/intake-partners/${IntakePartnerId}/hospitality-stays`),

  createNewStay: (formValues: HospitalityStayForm) =>
    apiFetch(`${INTAKE_BASE_PATH}/hospitality-stays/create`, {
      method: 'POST',
      body: formValues,
    }),

  editStay: ({
    hospitalityStayUuid,
    formValues,
  }: {
    formValues: HospitalityEditForm;
    hospitalityStayUuid: string;
  }) =>
    apiFetch(`${INTAKE_BASE_PATH}/hospitality-stays/${hospitalityStayUuid}/edit`, {
      method: 'POST',
      body: formValues,
    }),

  requestPickup: (hospitalityStayUuid: string) =>
    apiFetch(`${INTAKE_BASE_PATH}/hospitality-stays/${hospitalityStayUuid}/pickUp`, {
      method: 'PUT',
    }),

  requestDropoff: (hospitalityStayUuid: string) =>
    apiFetch(`${INTAKE_BASE_PATH}/hospitality-stays/${hospitalityStayUuid}/dropOff`, {
      method: 'PUT',
    }),

  closeStay: (hospitalityStayUuid: string) =>
    apiFetch(`${INTAKE_BASE_PATH}/hospitality-stays/${hospitalityStayUuid}/close`, {
      method: 'PUT',
    }),
};
